export const DV_CODE_LOADING_TIME_SW =
    'fin_credit_abroad_dv_code_loading_time_sw';
export const DV_CODE_IMAGE_LOADING_TIME_SW =
    'fin_credit_abroad_dv_code_image_loading_time_sw';
export const DV_CODE_SW = 'fin_credit_abroad_dv_code_sw';
export const DV_CODE_IMAGE_SW = 'fin_credit_abroad_dv_code_image_sw';
export const DV_CODE_FULL_SW = 'fin_credit_abroad_dv_code_full_sw';
export const DV_CODE_TIME_SW = 'fin_credit_abroad_dv_code_time_sw';
export const DV_CODE_TIME_EX = 'fin_credit_abroad_dv_code_time_ex';
export const DV_CODE_CK = 'fin_credit_abroad_dv_code_ck';
export const DV_CODE_TYP = 'fin_credit_abroad_dv_code_typ';
export const DV_CODE_BT = 'fin_credit_abroad_dv_code_bt';
export const DV_CODE_JUMP_BT = 'fin_credit_abroad_dv_code_jump_bt';

export const VERIFICATION_CODE_LOADING_TIME_SW =
    'fin_credit_abroad_verification_code_loading_time_sw';
export const VERIFICATION_CODE_SW = 'fin_credit_abroad_verification_code_sw';
export const VERIFICATION_CODE_TIME_SW =
    'fin_credit_abroad_verification_code_time_sw';
export const VERIFICATION_CODE_EX = 'fin_credit_abroad_verification_code_ex';
export const VERIFICATION_CODE_CK = 'fin_credit_abroad_verification_code_ck';
export const VERIFICATION_CODE_TYP = 'fin_credit_abroad_verification_code_typ';
export const VERIFICATION_CODE_PHONE_BT =
    'fin_credit_abroad_verification_code_phone_bt';
export const VERIFICATION_CODE_BT = 'fin_credit_abroad_verification_code_bt';
export const VERIFICATION_CODE_WAITING_TIME_SW =
    'fin_credit_abroad_verification_code_waiting_time_sw';
export const VERIFICATION_CODE_TYPING_TIME_SW =
    'fin_credit_abroad_verification_code_typing_time_sw';
export const VERIFICATION_CODE_AGAIN_BT =
    'fin_credit_abroad_verification_code_again_bt';

export const CHANGE_PHONE_POPUP_LOADING_TIME_SW =
    'fin_credit_abroad_change_phone_popup_loading_time_sw';
export const CHANGE_PHONE_POPUP_SW =
    'fin_credit_abroad_change_phone_popup_sw';
export const CHANGE_PHONE_POPUP_TIME_SW =
    'fin_credit_abroad_change_phone_popup_time_sw';
export const CHANGE_PHONE_POPUP_EX = 'fin_credit_abroad_change_phone_popup_ex';
export const CHANGE_PHONE_POPUP_CK =
    'fin_credit_abroad_change_phone_popup_ck';
export const CHANGE_PHONE_POPUP_TYP =
    'fin_credit_abroad_change_phone_popup_typ';
export const CHANGE_PHONE_POPUP_PHONE_BT =
    'fin_credit_abroad_change_phone_popup_phone_bt';
export const CHANGE_PHONE_POPUP_JUMP_BT =
    'fin_credit_abroad_change_phone_popup_jump_bt';
